import axios from "axios";
import { useState, useEffect } from 'react';
import { API_URL } from '../../../constants';
//import { useAuth } from '../../../provider';
//import { useLocation } from "react-router-dom";
import OnboardingStep4 from "./Steps/OnboardingSteps4";
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import Grid from '@mui/material/Grid';
import PageProtectedNew from "../../../components/Page/PageProtectedNew";
import ButtonForm from '../../../components/Button/ButtonForm';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';



export default function OnboardingCollection() {
    
//const { state } = useAuth();

const customersample = `${API_URL}/api/samplecollection`

    const [custsample, setCustsample] = useState(null);
    const [custconf, setCustconf] = useState(null);
    
    const [error, setError] = useState(null);
    const [message, setMessage] = useState("");

    useEffect(() => { retrieveCustomerSample() }, []);
  
    const retrieveCustomerSample = () => {
      axios.get(customersample)
        .then((res) => {
          setCustsample(res.data)

        })
        .catch(function (error) {
          if (error.response) {
            // Request made and server responded
            setError(error.response.data);
          } else if (error.request) {
            // The request was made but no response was received
            setError("The request was made but no response was received.");
          } else {
            // Something happened in setting up the request that triggered an Error
            setError("Error: " + error.message);
          }
        });
    };


const confirmCustomerSample = () => {
      
      let sample_id = custsample.map((i) => i.id)
      const confirmsample_url = `${API_URL}/api/sampleconfirm/${sample_id}/`
      axios.post(confirmsample_url)
        .then((res) => {
          setCustconf(res.data)
        })
        .catch(function (error) {
          if (error.response) {
            // Request made and server responded
            setError(error.response.data);
          } else if (error.request) {
            // The request was made but no response was received
            setError("The request was made but no response was received.");
          } else {
            // Something happened in setting up the request that triggered an Error
            setError("Error: " + error.message);
          }
        });
    };





return (
<>

<PageProtectedNew
    
main = {<>

{custsample ? 

<Grid container spacing={1}>
     
        <Grid size={{ xs: 12, md: 5 }} sx={{p:4, display: 'flex', justifyContent: 'center', alignItems: 'center',}}> <OnboardingStep4 />  </Grid> 
     
        <Grid size={{ xs: 12, md: 7 }} sx={{mr: {xl:'0'}, pr: {lg: '8rem', xl: '0rem'}, }}> 
        
        <Grid container spacing={1}>                
         
            <Grid size={12}  >  
            
             
                <Card variant="outlined" sx={{ width: {xs: 300, sm: 400, md: 400, lg: 400, xl: 400}, 
                                height: {xs: 'auto', sm: 'auto', md: 'auto', lg: 'auto', xl: 'auto'}, 
                                bgcolor: 'grey.C100', borderColor: 'grey.C700', borderRadius: "12px",  
                                m:8
                                 }}>
                <CardContent sx={{p:4}}>
                
                  <Typography variant="h5" gutterBottom sx={{mb:4, fontWeight: 400}}>  PLEASE CONFIRM SAMPLE IDs:  </Typography>
                  
                  {custsample.map((i, index) => 

                        <Typography variant="h6" key={index} > 

                          stool sample: &nbsp;&nbsp; {i.samplecollection_number_stool} <br />
                          blood sample: &nbsp;&nbsp;{i. samplecollection_number_blood} <br />
                          sulliva sample:  &nbsp;&nbsp;{i. samplecollection_number_sulliva} <br />

                      </Typography>
                    )}
                    
                    <form action={confirmCustomerSample}>
                        <ButtonForm name={'Confirm'} />
                    </form>    
            
                </CardContent>
                </Card>
                  
            </Grid>
            
            <Grid size={{xs:12, xl:6}} sx={{mr: {xs:4, sm: 0 }, mt: {xs:4, }, mb: {xs:2, sm: 0 }, display: 'flex', justifyContent: 'center',}}>  
                      {custconf && <Alert severity="info" variant="filled" sx={{borderRadius: '18px', p:2}}> 
                                      <Typography variant="h6" sx={{ fontFamily: 'Arial', fontWeight: 600}}>
                                      Thank you for confirming sample IDs. Please return the samples now according to instructions. 
                                      We will process samples as soon as possible and will inform you when results are available on the platform. 
                                      </Typography> 
                                  </Alert> }
            </Grid>  
            
            
            </Grid>  

        </Grid>
    </Grid>
        
  :        
 
             <Grid size={{xs:12, xl:11}} sx={{mr: {xs:4, sm: 0 }, mt: {xs:4, }, mb: {xs:2, sm: 0 }, display: 'flex', justifyContent: 'center',}}>  
                      {message && <Alert severity="info" variant="filled" sx={{borderRadius: '18px', p:2}}> 
                                      <Typography variant="h6" sx={{ fontFamily: 'Arial', fontWeight: 600}}>{message} </Typography> 
                                  </Alert> }
            </Grid>  
}
  
  </>}
/>
</>
)}